export enum OperationalFileType {
  Import = 0,
  Export = 1,
  CrossTrade = 2,
  Warehousing = 3
}